import React, { useEffect, useState } from "react";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import { PieChart } from "react-minimal-pie-chart";
import styled from "styled-components";

import {
  Button,
  DatePicker,
  Form,
  message,
  PageHeader,
  Segmented,
  Table,
} from "antd";
import Pagination from "react-js-pagination";
import { TeamOutlined } from "@ant-design/icons";
import { dateToCompactString, dateToString } from "../../util/common";
import {
  FlexRowContainer,
  FlexRowEndContainer,
  FlexRowReverseContainer,
} from "../../component/Common/Container.styles";

const ChartDesc = styled.div`
  background-color: ${(props) => {
    return props.color;
  }};
  width: 20px;
  height: 20px;
  margin-bottom: 5px;
  margin-right: 3px;
  border-radius: 10px;
`;

const StatIconItem = ({ label, value }) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        border: "1px solid rgba(0,0,0,0.2)",
        padding: "10px 20px",
        borderRadius: "10px",
        margin: "0 5px",
      }}
    >
      <TeamOutlined />
      <div style={{ fontWeight: "800" }}>{value}</div>
      <div style={{ fontSize: "0.7rem" }}>{label}</div>
    </div>
  );
};

const StatItem = ({ label, value }) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        border: "1px solid rgba(0,0,0,0.2)",
        padding: "10px 30px",
        borderRadius: "10px",
        margin: "0 5px",
      }}
    >
      <div style={{ fontSize: "0.7rem" }}>{label}</div>
      <div style={{ fontWeight: "800" }}>{value}</div>
    </div>
  );
};

export default function Main() {
  const colors = [
    "#f6fafd",
    "#e2eff9",
    "#cce4f5",
    "#b5d8f0",
    "#9bcaeb",
    "#7dbae5",
    "#5aa7de",
    "#2d8fd5",
  ].reverse();

  const [loading, setLoading] = useState(true);
  const [total, setTotal] = useState(0);
  const [users, setUsers] = useState([]);
  const [data, setData] = useState({});
  const [current, setCurrent] = useState(
    Number(sessionStorage.getItem("page")) ?? 1
  );

  const navigate = useNavigate();

  const onChange = (page) => {
    setCurrent(page);
    sessionStorage.setItem("page", page);
  };

  useEffect(() => {
    // userAPI
    //   .getUsers({ isMain: 1 })
    //   .then((res) => {
    //     if (res.data.linusCode === 1) {
    //       setData(res.data.data);
    //       setTotal(res.data.data.user.totalUser);
    //       setUsers(
    //         Object.keys(res.data.data.user)
    //           .filter((i) => i !== "totalUser")
    //           .map((r, idx) => {
    //             return {
    //               ...r,
    //               key: r,
    //               title: `${r} 대`,
    //               color: colors[idx],
    //               value: res.data.data.user[r],
    //             };
    //           })
    //       );
    //       setLoading(false);
    //     } else if (res.data.linusCode === -1) {
    //       navigate("/sign-in");
    //     } else {
    //       alert(res.data.data.msg);
    //     }
    //   })
    //   .catch((err) => {
    //     console.log(err.response);
    //     if (err.response?.data?.linusCode === -1) {
    //       navigate("/sign-in");
    //     }
    //   });
  }, []);

  return <div style={{ display: "flex", flexDirection: "column" }}></div>;
}
